import React from 'react';
import {
    isAndroidDevice,
    isAppleDevice,
} from '../Donee/components/common/utils';
import { assetUrl } from '../../utils/webConfig';

type AppStoreBadgesProps = {
    onIosClick: () => void;
    onAndroidClick: () => void;
    isLoading?: boolean;
};

const Spinner = () => (
    <span
        role="status"
        aria-label="Loading"
        className="pointer-events-none absolute left-1/2 top-1/2 z-[1] h-[22px] w-[22px] -translate-x-1/2 -translate-y-1/2 animate-spin rounded-full border-2 border-[#D0CFD9] border-t-guiding-violet"
    />
);

const StoreBadge: React.FC<{
    id: string;
    label: string;
    src: string;
    onClick: () => void;
    isLoading?: boolean;
}> = ({ id, label, src, onClick, isLoading }) => (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
        id={id}
        aria-label={label}
        rel="noreferrer"
        onClick={isLoading ? undefined : onClick}
        aria-busy={isLoading || undefined}
        className={`relative inline-block transition-[filter] duration-150 ease-in-out after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:bg-[linear-gradient(90deg,rgba(255,255,255,0)_0%,rgba(255,255,255,0.55)_50%,rgba(255,255,255,0)_100%)] after:bg-[length:200%_100%] after:content-[''] ${
            isLoading
                ? 'pointer-events-none cursor-wait grayscale-[60%] after:animate-shimmer after:opacity-100'
                : 'cursor-pointer after:opacity-0'
        }`}
    >
        <img
            src={src}
            alt=""
            className={`ml-[6px] mt-[5px] transition-opacity duration-150 ease-in-out ${
                isLoading ? 'opacity-35' : 'opacity-100'
            }`}
        />
        {isLoading && <Spinner />}
    </a>
);

export const AppStoreBadges: React.FC<AppStoreBadgesProps> = ({
    onIosClick,
    onAndroidClick,
    isLoading,
}) => (
    <>
        {!isAndroidDevice() && (
            <StoreBadge
                id="app-store-badge"
                label="Download on the App Store"
                src={assetUrl('/images/svg/app-store-badge.svg')}
                onClick={onIosClick}
                isLoading={isLoading}
            />
        )}
        {!isAppleDevice() && (
            <StoreBadge
                id="google-play-badge"
                label="Get it on Google Play"
                src={assetUrl('/images/svg/google-play-badge.svg')}
                onClick={onAndroidClick}
                isLoading={isLoading}
            />
        )}
    </>
);
